import clsx from "clsx"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"
import { motion } from "framer-motion"
import { useState } from "react"

export const meta: BlockMeta = {
  title: "FAQ Item",
  conditions: {
    postTypes: ["faq"],
  },
}

export default defineBlock("faq/faq-item", (props) => {
  const [expanded, setExpanded] = useState(!!env.admin)
  return (
    <div className="stack-y-3" data-transition="children/fade">
      <button type="button" className="stack-x-0 type-title-xs-medium text-left" onClick={() => setExpanded(!expanded)}>
        <span className="block w-5 flex-shrink-0 text-center" aria-hidden>
          {expanded ? "-" : "+"}
        </span>
        <EditableText store="label" placeholder="Enter a question" disableLineBreaks inlineToolbar={false} />
      </button>
      <motion.div initial={{ height: 0 }} animate={{ height: expanded ? "auto" : 0 }} className="overflow-hidden [&_p:first-child]:!mt-0 [&_p:last-child]:!mb-0">
        <div className="pt-1 pb-6 pl-5 rich-wysiwyg">
          <InnerBlocks allowedBlocks={["core/paragraph", "core/list", "content/button"]} template={[["core/paragraph", {}]]} appender={{ type: "default" }} />
        </div>
      </motion.div>
    </div>
  )
})
